package fr.manyverse.app.presentation.viewmodel

import fr.manyverse.app.domain.model.GameTable
import fr.manyverse.app.domain.usecase.JoinGameTableUseCase
import fr.manyverse.app.presentation.state.AsyncUiState
import kotlinx.coroutines.flow.MutableStateFlow
import kotlinx.coroutines.flow.StateFlow
import kotlinx.coroutines.flow.asStateFlow

class TableJoiningViewModel(
    private val joinGameTableUseCase: JoinGameTableUseCase
) : BaseViewModel() {

    private val _joinTableState = MutableStateFlow<AsyncUiState<GameTable>>(AsyncUiState.Idle)
    val joinTableState: StateFlow<AsyncUiState<GameTable>> = _joinTableState.asStateFlow()

    fun joinTable(code: String, userId: String) {
        launchAsync(_joinTableState) {
            joinGameTableUseCase(code, userId)
        }
    }

    fun resetJoinTableState() {
        resetState(_joinTableState)
    }
}
